export const ACCENTUATION_LABEL = 'Accentuation';
export const COLUMNS_LABEL = 'Colonnes';
export const ROWS_LABEL = 'Lignes';
